import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType, HttpHeaders } from '@angular/common/http';
import { AuthenticationService } from '../../authentication.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  httpUrl:any
  constructor(private http: HttpClient  ,private  auth:AuthenticationService) {
    this.httpUrl = auth.httpUrl

  }
    async getallComplaints(obj:any) {
    const resp = await this.http.get<any>(this.httpUrl + '/sdp/officer/dashboard/getDashboardDtl' + obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }

    async getDashoard(obj:any) {
    const resp = await this.http.get<any>(this.httpUrl + '/sdp/mc/dashboard/getDashoard' + obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }
    async getdeptWiseGri(obj:any) {
    const resp = await this.http.get<any>(this.httpUrl + '/sdp/mc/dashboard/getdeptWiseGri' + obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }
}
